import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.note');
import { OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-note',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.note/view.scss */
:host {
  display: none;
}`],
})
export class ComponentNoteComponent implements OnInit, OnDestroy {
    @Input() socket: any = null;
    @Input() contextTargetSid: string = '';
    @Input() remotePlayers: any = {};
    @Input() allRemotePlayers: any = {};

    @Output() modalRequest = new EventEmitter<{ mode: string, title: string, data?: any }>();

    public noteToast: any = null;
    private noteToastTimeout: any = null;
    public incomingNoteData: any = null;
    public receivedNotes: Array<{ from: string, fromUserId?: string, message: string, time: Date, read: boolean }> = [];

    public get unreadNoteCount(): number {
        return this.receivedNotes.filter(n => !n.read).length;
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnDestroy() {
        if (this.noteToastTimeout) clearTimeout(this.noteToastTimeout);
    }

    public async openNoteDetail(note: any) {
        this.incomingNoteData = { from: note.from, fromUserId: note.fromUserId || '', message: note.message };
        this.modalRequest.emit({
            mode: 'incoming_note',
            title: '받은 쪽지',
            data: { incomingNote: this.incomingNoteData }
        });
        await this.service.render();
    }

    public async deleteNote(index: number) {
        this.receivedNotes.splice(index, 1);
        await this.service.render();
    }

    public async onNoteSend(event: any) {
        if (!this.socket?.connected) return;
        if (typeof event === 'string') {
            this.socket.emit("note", { target_sid: this.contextTargetSid, message: event });
        } else if (event.targetSid && event.message) {
            this.socket.emit("note", { target_sid: event.targetSid, message: event.message });
        }
        await this.service.render();
    }

    public async openNoteComposeModal() {
        this.modalRequest.emit({
            mode: 'message',
            title: '쪽지 보내기',
            data: { recipientName: '', recipientLocked: false }
        });
        await this.service.render();
    }

    public async onNoteReply(fromNickname: string) {
        let targetSid = '';
        // allRemotePlayers (전체 접속자) 에서 먼저 검색, 없으면 remotePlayers에서 검색
        const searchPools = [this.allRemotePlayers || {}, this.remotePlayers || {}];
        for (const pool of searchPools) {
            for (const sid of Object.keys(pool)) {
                if (pool[sid].nickname === fromNickname) {
                    targetSid = sid;
                    break;
                }
            }
            if (targetSid) break;
        }
        this.modalRequest.emit({
            mode: 'message',
            title: '쪽지 보내기',
            data: { recipientName: fromNickname, recipientLocked: true, targetSid }
        });
        await this.service.render();
    }

    public showNoteToast(data: any) {
        this.noteToast = data;
        if (this.noteToastTimeout) clearTimeout(this.noteToastTimeout);
        this.noteToastTimeout = setTimeout(() => {
            this.noteToast = null;
            this.service.render();
        }, 3000);
        this.service.render();
    }

    public addReceivedNote(from: string, message: string, fromUserId?: string) {
        this.receivedNotes.push({ from, fromUserId: fromUserId || '', message, time: new Date(), read: false });
        this.service.render();
    }
}

export default ComponentNoteComponent;